import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { RestApiService } from '../common-app/service/rest-api.service';
import { Kvaw0600Vo } from './kvaw0600.vo';

/**
 * サーバとの通信を行う。
 * @see WebAPI仕様_KVAW0600（日報情報登録）.xlsx
 */
@Injectable()
export class Kvaw0600Service {

  /** 検索対象 */
  private static TARGET = 'kvaw0600';

  constructor(
    private restApiService: RestApiService,
  ) { }

  /**
   * 日報情報を登録する
   *
   * @param reportInfoVo 日報情報VO
   */
  registerReportInfo(reportInfoVo?: Kvaw0600Vo): Observable<Kvaw0600Vo> {
    return this.restApiService.register(Kvaw0600Service.TARGET, reportInfoVo);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/kvaw0600.service.ts